import React from "react";
import { useCookies } from "react-cookie";
import { Box, Grid, Paper, Tab, Tabs, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import {
  CssBox,
  CssButton,
} from "../../NewProjectView/components/StyledComponent";
import { GridContentDashboard } from "../../NewProjectView/components/CustomGrids";
import WorkOutlineOutlinedIcon from "@mui/icons-material/WorkOutlineOutlined";
import StepperStatus from "../components/StepperStatus";
import { useDispatch, useSelector } from "react-redux";
import { fetchProjects } from "../../../store/asyncs/ProjectAsyncs";

const styles = {
  titleInput1: {
    color: "#46bda7",
    fontWeight: "lighter",
  },
  subtitleInput1: {
    fontWeight: "bolder",
    color: "#002f4f",
  },
  cssLink: {
    textDecoration: "none",
    display: "inline-block",
    width: "100%",
    marginBottom: "20px"
  },
  typoMenuLeft1: {
    color: "#002f4f",
  },
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const DashboardPage = () => {
  const [cookies] = useCookies([]);
  const [value, setValue] = React.useState(0);

  const projects = useSelector(state => state.project.data);

  const dispatch = useDispatch();

  const setProjectData = React.useCallback(async () => {
    await dispatch(fetchProjects())
  }, [dispatch]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  React.useEffect(() => {
    setProjectData()
  }, [cookies, setProjectData ]);
  return (
    <>
      <Grid container>
        <Grid
          item
          paddingTop={4}
          paddingLeft={2}
          paddingRight={2}
          xs={4}
          md={3}
          lg={2}
        >
          <Link to="/dashboard" style={styles.cssLink}>
            <CssBox>
              <Typography variant="subtitle2" style={styles.subtitleInput1}>
                Mes projets
              </Typography>
              <Typography variant="body2" style={styles.typoMenuLeft1}>
                Liste de mes projets
              </Typography>
            </CssBox>
          </Link>
          <Link to="/ajouter-titre" style={styles.cssLink}>
            <CssBox>
              <Typography variant="subtitle2" style={styles.subtitleInput1}>
                Nouveau projet
              </Typography>
              <Typography variant="body2" style={styles.typoMenuLeft1}>
                Creer un projet
              </Typography>
            </CssBox>
          </Link>
        </Grid>
        <GridContentDashboard
          item
          xs={8}
          md={9}
          lg={10}
        >
          <Box sx={{ borderBottom: 1, borderColor: 'divider', marginTop: 5 }}>
            <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Mes projets" {...a11yProps(0)} />
            </Tabs>
          </Box>
          <TabPanel value={value} index={0}>
            <Grid
              container
              direction="column"
              paddingLeft={5}
              paddingRight={5}
              marginTop={5}
              marginBottom={30}
            >
              <Box marginTop={5}>
                {projects && projects.data && projects.data.projects && projects.data.projects.map((project, i) => (
                  <Paper
                    key={project._id}
                    elevation={0}
                    sx={{
                      padding: "2% 3%",
                      boxShadow: "0 2px 10px rgba(0,0,0,.1)",
                      borderRadius: "10px",
                      marginBottom: 5,
                    }}
                  >
                    <Grid container direction="row" alignItems="center">
                      <Grid item xs={2}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Box
                            sx={{
                              width: "100px",
                              height: "100px",
                              textAlign: "center",
                              borderRadius: "50%",
                              backgroundColor: "#46bda785",
                            }}
                          >
                            <WorkOutlineOutlinedIcon
                              sx={{
                                fontSize: "3rem",
                                marginTop: "25%",
                                color: "rgb(0, 47, 79)",
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                      <Grid item xs={8}>
                        <Box sx={{ padding: "0 7%", marginBottom: 2 }}>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: "bolder" }}
                            color="secondary"
                          >
                            {project.title}
                          </Typography>
                          <Typography color="secondary">{project.categories.map((c,i) => (<span key={i}>{c}, </span>))}</Typography>
                        </Box>
                        <StepperStatus />
                      </Grid>
                      <Grid item xs={2}>
                        <Box
                          sx={{
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <CssButton variant="contained" sx={{ width: "50%" }}>
                            Voir
                          </CssButton>
                        </Box>
                      </Grid>
                    </Grid>
                  </Paper>
                ))}
              </Box>
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            Item Two
          </TabPanel>
          <TabPanel value={value} index={2}>
            Item Three
          </TabPanel>
          
        </GridContentDashboard>
      </Grid>
    </>
  );
};

export default DashboardPage;
